export default {
    fontWeight400: "400",
    fontWeight500: "500",
    fontWeight600: "600",
    fontWeightBold: "bold",
    fontWeight700:"700",

}